import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserPlus, Lock } from "lucide-react";
import { api } from "@/lib/api";

const STATIC = "/legion/member-preview.html";

const buildLive = (html, seed) => {
  const lines = html.split("\n");
  const i = lines.findIndex((l) => l.startsWith("const __SEED = "));
  if (i === -1) return null;
  const { updatedAt, ...data } = seed;
  lines[i] = "const __SEED = " + JSON.stringify(data).replace(/<\//g, "<\\/") + ";";
  let out = lines.join("\n").replace("<head>", `<head><base href="${window.location.origin}/legion/">`);
  const pv = out.indexOf("const __pv");
  const end = pv === -1 ? -1 : out.indexOf("</script>", pv);
  if (end !== -1) out = out.slice(0, end + 9) + `\n<script src="member-shim.js?v=${Date.now()}"></script>` + out.slice(end + 9);
  out = out.replace("section.hc-ask,#ggSubmit,#ggMineWrap,#ggInboxWrap,#ggGoSubmit,.gg-add,.gg-report,.gg-footlinks{display:none !important;}", "section.hc-ask,#ggInboxWrap{display:none !important;}");
  out = out.replace("Nothing on this page can be edited or submitted.", "Have a gear setup that works? Send it in from the Gear Guide tab.");
  if (updatedAt) {
    const when = new Date(updatedAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    out = out.replace(/Read-only snapshot, updated [A-Z][a-z]{2} \d{1,2}, \d{4}\./, `Live roster, last updated ${when}.`);
  }
  return out;
};

export default function MemberPage() {
  const [doc, setDoc] = useState(null);
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    document.title = "We Are Legion · Member Preview";
    Promise.all([fetch(STATIC).then((r) => r.text()), api.get("/public/preview-seed").then((r) => r.data)])
      .then(([html, seed]) => { const live = buildLive(html, seed); live ? setDoc(live) : setFallback(true); })
      .catch(() => setFallback(true));
  }, []);

  return (
    <div className="lg">
      {(doc || fallback) && (
        <iframe title="Member Preview" className="lg-frame" style={{ top: 0, height: "100vh" }} data-testid="member-preview-frame"
          {...(doc ? { srcDoc: doc } : { src: STATIC })} />
      )}
      <Link to="/join" className="lg-fab" data-testid="member-join-link"><UserPlus size={16} /> Enlist / Submit stats</Link>
      <Link to="/deck" className="lg-leader" data-testid="member-leader-link"><Lock size={13} /> Leader sign in</Link>
    </div>
  );
}
